import React from "react";
import Wrapper from "../components/Wrapper";
import Spacer from "../components/Spacer";
import { MetaText, SubTitleText, TitleText } from "../components/Typography";
import { BackNav } from "../components/Navigation";
import Logo from "../components/Logo";

export default function UserDataPresenter(props) {
  return (
    <>
      <Spacer size={2} />
      <Wrapper
        className="flex-center-vertical"
        style={{ minHeight: "90vh", borderRadius: "18px 18px 0 0" }}
      >
        <Spacer size={3} />
        <div style={{ alignSelf: "flex-start" }}>
          <BackNav />
        </div>
        <Spacer size={1} />
        <TitleText>Data Usage & Collection</TitleText>
        <Spacer size={3} />
        <div style={{ textAlign: "justify", maxWidth: 800 }}>
          <MetaText>
            This application collects data from your use. The data collected is
            solely used in academic purposes in order for us, Patrik Larsson &
            Samuel Ribaric, to write our Bachelors Thesis report. The data
            collected is non-personal and anonymized. The application is not in
            use outside of the study experiment, and only the study experiments'
            participants have access to the application.
          </MetaText>
          <Spacer size={3} />
          <SubTitleText style={{ textAlign: "left", padding: "0 16px" }}>
            The data collected by this app consists of:
          </SubTitleText>
          <Spacer size={1} />
          <MetaText>• Time spent in chat </MetaText>
          <MetaText>• Whether or not you found the chatbot helpful </MetaText>
          <MetaText>• Which task you sought help for </MetaText>
          <Spacer size={3} />
          <MetaText>
            By using this web application you agree that your data will be
            collected and later analyzed in academic purposes.
          </MetaText>
        </div>
        <Spacer size={8} />
        <Logo />
        <Spacer size={2} />
        <SubTitleText>Thank you for your participation!</SubTitleText>
      </Wrapper>
      <Wrapper
        className="flex-center-vertical"
        style={{ minHeight: "5vh", borderRadius: "0 0 18px 18px" }}
      >
        <MetaText>Developed by Patrik Larsson & Samuel Ribaric 2023</MetaText>
      </Wrapper>
    </>
  );
}
